import { Flex, Heading, Stack, Text } from "@chakra-ui/react";
import React from "react";

export default function WhySection() {
  return (
    <Flex
      bgImage={"url('/images/about/banner2.png')"}
      height={{md:"550px"}}
      py={{base:5,md:0}}
      bgSize={"cover"}
      bgRepeat="no-repeat"
      justifyContent={"center"}
      alignItems="end"
      flexDirection="column"
      color="white"
      gap={5}
      backgroundPosition="center"
      my={{base:6,md:10}}
    >
      <Stack
        alignItems="start"
        pr={10}
        pl={{ base: 10, md: 0 }}
        maxW={{ md: "80%", xl: "60%" }}
      >
        <Heading
          fontWeight={"semibold"}
          fontSize={{ base: "22px", "2xl": "40px" }}
        >
          Why Choose Decolance?
        </Heading>
        <Text
          fontSize={{ base: "10px", md: "16px", "2xl": "21px" }}
          color="white"
        >
          Your business is your greatest asset. It represents years of hard
          work, innovation, concept creation, and strategic development. Now,
          you need a trusted freelancer who will protect and grow your business
          with top-quality digital services to help boost profitability,
          increase brand awareness, and enter emerging markets. Here you’ll find
          talented freelancers from all over the world, giving you unlimited
          possibilities for collaboration, innovation, and inspiration.
          Together, you can continue to write your success story right here at
          Decolance.
        </Text>
        <Text
          fontSize={{ base: "10px", md: "16px", "2xl": "21px" }}
          color="white"
        >
          Our revolutionary platform is driven by a cutting-edge settlement
          process, using only cryptocurrencies launched on Binance Smart Chain
          as a means of settlement, with no third-party interference. The smooth
          and seamless process will have you returning time and again to partner
          with your favorite freelancers.
        </Text>
        <Text fontSize={{ base: "12px",md: "17px", "2xl": "21px" }} color="white">
          Find the best global freelance talent at Decolance, where professional
          collaboration is guaranteed.
        </Text>
      </Stack>
    </Flex>
  );
}
